const CATEGORY_TAGLINES = {
  Tools: 'Ready to build',
  Electronics: 'Powered up',
  Sports: 'Game on',
  Outdoors: 'Adventure awaits',
  Kitchen: 'Ready to cook',
  Garden: 'Growing season',
  Party: 'Time to celebrate',
  'Baby & Kids': 'Little moments',
  Furniture: 'Make it home',
  Books: 'A story inside',
  Textbooks: 'Study smart',
  Other: 'Something useful',
};

export const getCategoryPlaceholder = (category) => {
  const label = CATEGORY_TAGLINES[category] ? category : 'Other';
  const tagline = CATEGORY_TAGLINES[label];
  const initial = label.charAt(0);
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='800' height='600' viewBox='0 0 800 600'><rect width='800' height='600' fill='#F2EDE3'/><circle cx='400' cy='250' r='95' fill='#D97757' opacity='0.12'/><circle cx='400' cy='250' r='62' fill='#D97757' opacity='0.2'/><text x='400' y='272' font-family='Georgia, serif' font-size='58' fill='#C56547' text-anchor='middle'>${initial}</text><text x='400' y='395' font-family='Verdana, sans-serif' font-size='30' font-weight='bold' fill='#596652' text-anchor='middle'>${label}</text><text x='400' y='438' font-family='Verdana, sans-serif' font-size='19' fill='#9AA391' text-anchor='middle'>${tagline} - photo coming soon</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
